<template>
  <div class="c-radio-options-box__wrapper" v-bind:class="showBefore">
    <div class="c-radio-options-box">
      <div class="c-radio-options-box__question">
        <h2 class="c-radio-options-box__title">{{ question.label }}</h2>
        <div class="c-rap-rte" v-if="question.helpText" v-html="question.helpText"></div>
      </div>
      <div 
        class="c-radio-options-box__answers"
        v-bind:class="columnSize">

        <div 
          class="c-radio-options-box__answer" 
          v-bind:key="index"
          v-for="(option, index) in question.options">
          <div class="c-radio-options-box__image" v-if="option.img">
            <img v-bind:src="option.img" alt="option.imgAlt" />
          </div>
          <div class="c-radio-options-box__field-container">
            <input 
              class="c-radio-options-box__field" 
              type="radio" 
              v-bind:id="option.optionId"
              v-bind:name="question.id" 
              v-bind:value="option.value"
              v-model="question.answer"
              v-on:change="emitInput($event, index, question.id, option.nextId, option.final, option.upload)" />
            <label
              class="c-radio-options-box__label"
              v-bind:style="showIcon(option.ico)"
              v-bind:for="option.optionId">
                {{ option.label }}
            </label>
          </div>
        </div>

        <h3 v-if="question.answerLabel" class="c-radio-options-box__replay">
          You answered: {{ question.answerLabel }}
        </h3>

        <div class="c-rap-rte" v-if="cmsText" v-html="cmsText"></div>

        <div class="c-radio-options-box__actions" v-if="liveChat || externalLink">
          <button type="button" class="c-button c-button--brand c-button--text-center" v-if="liveChat">
            Live Chat
          </button>
          <a 
            class="c-button c-button--brand c-button--text-center"
            v-bind:href="externalLinkUrl"
            v-if="externalLink">
            {{ externalLinkText }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    index: {
      required: true,
      type: Number,
    },
    question: {
      required: true,
      type: Object,
    }
  },
  data() {
    return {
      cmsText: null,
      externalLink: null,
      externalLinkText: null,
      externalLinkUrl: null,
      liveChat: null,
    }
  },
  destroyed() {
    this.question.answer = '';
    this.question.answerLabel = '';
  },
  computed: {
    columnSize() {
      return this.question.options.length % 3 === 0 ? 'c-radio-options-box__answers--three-column' : 'c-radio-options-box__answers--two-column'; 
    },
    showBefore() {
      return this.index > 0 ? 'c-radio-options-box__wrapper--before' : '';
    }
  },
  methods: {
    emitInput(e, optionIndex, questionId, nextId, isFinal, offerUpload) {
      this.cmsText = this.question.options[optionIndex].text;
      this.externalLink = (this.question.options[optionIndex].linkText && this.question.options[optionIndex].linkUrl);
      this.externalLinkText = this.question.options[optionIndex].linkText;
      this.externalLinkUrl = this.question.options[optionIndex].linkUrl;
      this.liveChat = this.question.options[optionIndex].chat;
      this.$emit('input', e.target.value, this.index, questionId, nextId, isFinal, offerUpload);
    },
    showIcon(icon) {
      return `background-image:url('${icon}')`;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/components/consumer/report-a-problem/_vue/RadioOptions.vue